import { defineComponent } from 'vue'
import { mapState, mapActions } from 'vuex'
import { RepoListActions, RepositoryListModuleState } from '~/store/repository/list'

export default defineComponent({
  name: 'RepoListMixin',

  computed: {
    ...(mapState<RepositoryListModuleState>('repository/list', {
      repositoryList: (state: RepositoryListModuleState) => state.repositoryList,
      newRepos: (state: RepositoryListModuleState) => state.newRepos,
      repoWithActiveAnalysis: (state: RepositoryListModuleState) => state.repoWithActiveAnalysis,
      repoWithActiveAnalysisWithAnalyzers: (state: RepositoryListModuleState) =>
        state.repoWithActiveAnalysisWithAnalyzers,
      repoWithPendingAdhocRuns: (state: RepositoryListModuleState) =>
        state.repoWithPendingAdhocRuns,
      loading: (state: RepositoryListModuleState) => state.loading
    }) as {
      repositoryList: () => RepositoryListModuleState['repositoryList']
      newRepos: () => RepositoryListModuleState['newRepos']
      repoWithActiveAnalysis: () => RepositoryListModuleState['repoWithActiveAnalysis']
      repoWithActiveAnalysisWithAnalyzers: () => RepositoryListModuleState['repoWithActiveAnalysisWithAnalyzers']
      repoWithPendingAdhocRuns: () => RepositoryListModuleState['repoWithPendingAdhocRuns']
      loading: () => RepositoryListModuleState['loading']
    })
  },

  methods: {
    ...mapActions('repository/list', {
      fetchRepoList: RepoListActions.FETCH_REPOSITORY_LIST,
      fetchPendingAdHocRepoList: RepoListActions.FETCH_PENDING_ADHOC_REPOSITORY_LIST,
      fetchNewRepoList: RepoListActions.FETCH_NEW_REPOSITORY_LIST,
      fetchActiveAnalysisRepoList: RepoListActions.FETCH_ACTIVE_REPOSITORY_LIST,
      fetchActiveAnalysisRepoListWithAnalyzers:
        RepoListActions.FETCH_ACTIVE_REPOSITORY_LIST_WITH_ANALYZERS
    })
  }
})
